import React, { useState } from 'react';
import { Card, Table, Button, Space, Modal, Form, Input, Select, Upload, message } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons';

const { Option } = Select;

const ProductType = () => {
  const [types, setTypes] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [isTypeModalVisible, setIsTypeModalVisible] = useState(false);
  const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
  const [typeForm] = Form.useForm();
  const [templateForm] = Form.useForm();

  const typeColumns = [
    {
      title: '类型名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '产品数量',
      dataIndex: 'productCount',
      key: 'productCount',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => handleEditType(record)}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteType(record)}
          />
        </Space>
      ),
    },
  ];

  const templateColumns = [
    {
      title: '模板名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '适用类型',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => handleEditTemplate(record)}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteTemplate(record)}
          />
        </Space>
      ),
    },
  ];

  const handleAddType = () => {
    setIsTypeModalVisible(true);
  };

  const handleEditType = (record) => {
    typeForm.setFieldsValue(record);
    setIsTypeModalVisible(true);
  };

  const handleDeleteType = (record) => {
    Modal.confirm({
      title: '确认删除',
      content: '确定要删除这个商品类型吗？',
      onOk() {
        setTypes(types.filter(t => t.id !== record.id));
        message.success('删除成功');
      },
    });
  };

  const handleTypeModalOk = () => {
    typeForm.validateFields().then(values => {
      if (values.id) {
        setTypes(types.map(t => 
          t.id === values.id ? { ...t, ...values } : t
        ));
      } else {
        setTypes([...types, { ...values, id: Date.now() }]);
      }
      setIsTypeModalVisible(false);
      typeForm.resetFields();
      message.success('保存成功');
    });
  };

  const handleAddTemplate = () => {
    setIsTemplateModalVisible(true);
  };

  const handleEditTemplate = (record) => {
    templateForm.setFieldsValue(record);
    setIsTemplateModalVisible(true);
  };

  const handleDeleteTemplate = (record) => {
    Modal.confirm({
      title: '确认删除',
      content: '确定要删除这个模板吗？',
      onOk() {
        setTemplates(templates.filter(t => t.id !== record.id));
        message.success('删除成功');
      },
    });
  };

  const handleTemplateModalOk = () => {
    templateForm.validateFields().then(values => {
      if (values.id) {
        setTemplates(templates.map(t => 
          t.id === values.id ? { ...t, ...values } : t
        ));
      } else {
        setTemplates([...templates, { ...values, id: Date.now() }]);
      }
      setIsTemplateModalVisible(false);
      templateForm.resetFields();
      message.success('保存成功');
    });
  };

  return (
    <div>
      <Card title="商品类型管理" style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAddType}
          style={{ marginBottom: 16 }}
        >
          添加商品类型
        </Button>
        <Table
          columns={typeColumns}
          dataSource={types}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Card>

      <Card title="模板管理">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAddTemplate}
          style={{ marginBottom: 16 }}
        >
          添加模板
        </Button>
        <Table
          columns={templateColumns}
          dataSource={templates}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Card>

      <Modal
        title="商品类型信息"
        visible={isTypeModalVisible}
        onOk={handleTypeModalOk}
        onCancel={() => {
          setIsTypeModalVisible(false);
          typeForm.resetFields();
        }}
      >
        <Form
          form={typeForm}
          layout="vertical"
        >
          <Form.Item
            name="name"
            label="类型名称"
            rules={[{ required: true, message: '请输入类型名称' }]}
          >
            <Input placeholder="请输入类型名称" />
          </Form.Item>
          <Form.Item
            name="description"
            label="描述"
          >
            <Input.TextArea rows={4} placeholder="请输入描述" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="模板信息"
        visible={isTemplateModalVisible}
        onOk={handleTemplateModalOk}
        onCancel={() => {
          setIsTemplateModalVisible(false);
          templateForm.resetFields();
        }}
      >
        <Form
          form={templateForm}
          layout="vertical"
        >
          <Form.Item
            name="name"
            label="模板名称"
            rules={[{ required: true, message: '请输入模板名称' }]}
          >
            <Input placeholder="请输入模板名称" />
          </Form.Item>
          <Form.Item
            name="type"
            label="适用类型"
            rules={[{ required: true, message: '请选择适用类型' }]}
          >
            <Select placeholder="请选择适用类型">
              {types.map(type => (
                <Option key={type.id} value={type.id}>{type.name}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="file"
            label="模板文件"
            rules={[{ required: true, message: '请上传模板文件' }]}
          >
            <Upload>
              <Button icon={<UploadOutlined />}>上传模板文件</Button>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ProductType; 